import { AdministrationProvider } from '@openx/components-administration/lib/utils/context/AdministrationContext';
import { CoreProvider } from '@openx/components-core/utils/context/CoreContext';
import { DealProvider } from '@openx/components-deal/lib/utils/context/DealContext';
import { DealForecastProvider } from '@openx/components-deal/lib/utils/context/DealForecastContext/DealForecastProvider';
import { DealPromptDomainsProvider } from '@openx/components-deal-prompt/lib/utils/context/DealPromptDomainsContext';
import { DirectDealsProvider } from '@openx/components-direct-deals/lib/utils/context/DirectDealsContext';
import { OrganizationProvider } from '@openx/components-organization/lib/utils/context/OrganizationContext';
import { ProviderContextProvider } from '@openx/components-provider/lib/utils/context/ProviderContext';
import { SegmentProvider } from '@openx/components-segment/lib/utils/context/SegmentContext';
import { PermissionProvider } from '@openx/utils/permission/context/PermissionContext';
import type { Auth } from 'firebase/auth';
import { Outlet } from 'react-router';
import { AuthProvider } from '../components/AuthContext/AuthContext';
import { useAuth } from '../components/AuthContext/context';
import { GROWTHBOOK_SALT } from '../config';
import { administrationConfig } from './administration/administrationConfig';
import { coreConfig } from './core/coreConfig';
import { dealPromptConfig } from './deal-prompt/dealPromptConfig';
import { dealConfig } from './deals/dealConfig';
import { directDealsConfig } from './direct-deals/directDealsConfig';
import { organizationConfig } from './organization/organizationConfig';
import { PackageProviderWithAuth } from './package/PackageProviderWithAuth';
import { permissionConfig } from './permission/permissionConfig';
import { providerConfig } from './provider/providerConfig';
import { segmentConfig } from './segment/segmentConfig';
import { TargetingProviderWithAuth } from './targeting/utils/TargetingProviderWithAuth';

export interface ConfigProvidersProps {
  children: React.ReactNode;
  auth: Auth;
}

export function ConfigProviders({ children, auth }: ConfigProvidersProps) {
  return (
    <AuthProvider auth={auth}>
      {/* <PermissionProvider permissionConfig={permissionConfig}> */}
      <SessionDrill>
        <CoreProvider coreConfig={coreConfig}>
          <DealForecastProvider>
            <DealProvider dealConfig={dealConfig}>
              <PackageProviderWithAuth>
                <TargetingProviderWithAuth>
                  <SegmentProvider segmentConfig={segmentConfig}>
                    <AdministrationProvider administrationConfig={administrationConfig}>
                      <ProviderContextProvider providerConfig={providerConfig}>
                        <DirectDealsProvider directDealsConfig={directDealsConfig}>
                          <DealPromptDomainsProvider dealPromptDomainsConfig={dealPromptConfig}>
                            <OrganizationProvider organizationConfig={organizationConfig}>
                              {children}
                            </OrganizationProvider>
                          </DealPromptDomainsProvider>
                        </DirectDealsProvider>
                      </ProviderContextProvider>
                    </AdministrationProvider>
                  </SegmentProvider>
                </TargetingProviderWithAuth>
              </PackageProviderWithAuth>
            </DealProvider>
          </DealForecastProvider>
        </CoreProvider>
      </SessionDrill>
      {/* </PermissionProvider> */}
    </AuthProvider>
  );
}

// TODO: UIG-540 Temp Workaround for ACL Platform Share
export const SessionDrill = ({ children }) => {
  const { session } = useAuth();

  const permSession = session?.exchange_session;

  return (
    <PermissionProvider
      permissionConfig={permissionConfig}
      session={permSession}
      appName="oxs"
      userEmail={session?.email}
      growthBookSalt={GROWTHBOOK_SALT}
    >
      {children}
    </PermissionProvider>
  );
};

export const Config = ({ auth }: { auth: Auth }) => {
  return (
    <ConfigProviders auth={auth}>
      <Outlet />
    </ConfigProviders>
  );
};
